import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DoCheck,
  Input,
  OnInit,
} from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, SlicePipe } from '@angular/common';
import { BaseRules, Control, TextValues } from './delaware-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-delaware',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    CommonModule,
    TruncateModule,
    TooltipModule
  ],
  templateUrl: './delaware.component.html',
  styleUrl: './delaware.component.scss',
})
export class DelawareComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('delaware', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('delaware', null);
    }
  }
}
